import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp16};
  height: 100%;
  overflow: hidden;
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  padding-bottom: ${props => props.theme.spacing.sp16};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  flex-shrink: 0;
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  padding-top: ${props => props.theme.spacing.sp16};
  margin-bottom: ${props => props.theme.spacing.sp12};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  flex-shrink: 0;
`
